import React from 'react';
import { Button, StapleTableCell, StapleTableRow, Tooltip } from '@insurancemenu/imenu-components-lib';
import { Download } from '@insurancemenu/imenu-components-lib/dist/icons';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { FileAvailabilityRole } from 'types/policyService';
import { AccessTag } from 'components/common/general/AccessTag';
import { FileNameStyled, NameCellContentStyled, StapleTableCellStyled } from './styles';

interface Props {
  name: string;
  indexNumber: number;
  availability?: FileAvailabilityRole;
  onDownload: () => void;
}

export const TAG_AVAILABILITY_MAP: Record<FileAvailabilityRole, React.ReactNode> = {
  CELTIC: <AccessTag size="large" accessLimitation="Management Only" />,
  BROKER: null,
};

const DownloadFileTableRow: React.FC<Props> = ({ name, indexNumber, availability, onDownload }) => {
  return (
    <StapleTableRow>
      <StapleTableCell onClick={onDownload} width="30rem">
        <NameCellContentStyled>
          <span>
            <b>{`${indexNumber}. `}</b>
            <FileNameStyled>{name}</FileNameStyled>
          </span>
        </NameCellContentStyled>
      </StapleTableCell>
      <StapleTableCell width="8rem">{availability && TAG_AVAILABILITY_MAP[availability]}</StapleTableCell>
      <StapleTableCellStyled width="8rem">
        <Tooltip alignment={AlignmentTypes.LEFT_CENTER} label="Download File">
          <Button type="icon" color="primary" onClick={onDownload}>
            <Download width="2.4rem" height="2.4rem" />
          </Button>
        </Tooltip>
      </StapleTableCellStyled>
    </StapleTableRow>
  );
};

export default DownloadFileTableRow;
